/**
 * XableAI Personal Mode V1 Entry Point
 *
 * A person-owned AI workspace where users can:
 * - Own their work history
 * - Carry their AI memory
 * - Let an agent safely propose actions
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
